import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'qmed-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationComponent implements OnInit {

  isLoggedIn: boolean;

  constructor(private loginService: LoginService) {
    this.isLoggedIn = loginService.isLoggedIn();
  }

  ngOnInit() {
  }

  logout(): void {
    this.loginService.logout();
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/full-layout/navigation/navigation.component.ts